import React, { useContext, useEffect } from 'react';
import './CSS/App.css';
import Home from './components/Home';
import NavBar from './components/Nav';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { TrailContext } from './components/TrailContext'
import CurrentProvider from './components/CurrentContext';
import SignIn from './components/SignIn';
import UserWidget from './components/UserWidget';
import ThemeProvider from './components/ThemeContext';
import firebase from './firebase';
import Footer from './components/Footer';
import TrailEtiquette from './components/TrailEtiquette';
import AllTrails from './components/AllTrails';
import Displaydata from './components/Displaydata';
import SetData from './components/SetData';

function App() {

  const [trails] = useContext(TrailContext);
  
  useEffect(() => {
    firebase.analytics()
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <Router>
          <NavBar trails={trails} />
          <Switch>
            <Route exact path='/'>
              <Home />
            </Route>
            <Route path="/signin">
              <SignIn />
            </Route>
            <Route path="/etiquete">
              <TrailEtiquette />
            </Route>
            <Route exact path="/trails">
              <AllTrails />
            </Route>
            <CurrentProvider>
              <Route exact path="/trails/:trail" component={Displaydata} />
              <Route exact path="/trails/:trail/report" component={SetData} />
            </CurrentProvider>
          </Switch>
          <UserWidget />
          <Footer />
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
